<template>
  <Layout style="height: 100%" class="main">
    <Header class="header-con">
      <header-bar>
        <user :message-unread-count="unreadCount" :user-avatar="userAvatar" :user-name="userName" :mode="mode" />
        <!-- <Row type="flex" class="tags-wrap" :gutter="20">
          <Col span="4" @click.native="gpPage('communicateIndex')">
            <icon type="tongzhi1"></icon>
            通知
            <Badge dot v-if="totalUnreadCount">
              <a href="#" class="demo-badge"></a>
            </Badge>
          </Col>
          <Col span="4" @click.native="gpPage('communicationIndex')">
            <icon type="yijinggoutong"></icon>
            已经沟通
          </Col>
          <Col span="4" @click.native="gpPage('interviewIndex')">
            <icon type="mianshijilu"></icon>
            面试记录
          </Col>
          <Col span="4" @click.native="gpPage('collectionIndex')">
            <icon type="wodeshoucang"></icon>
            我的收藏
          </Col>
          <Col span="4" @click.native="gpPage('recommendIndex')">
            <icon type="gonghui"></icon>
            工会推荐
          </Col>
        </Row> -->
      </header-bar>
    </Header>
    <Layout>
      <Sider
        hide-trigger
        collapsible
        :width="150"
        :collapsed-width="50"
        v-model="collapsed"
        class="left-sider"
        :style="{ overflow: 'hidden' }"
      >
        <sider-trigger :collapsed="collapsed" icon="menu" @on-change="handleCollapsedChange"></sider-trigger>
        <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList">
          <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        </side-menu>
      </Sider>
      <Layout class="main-layout">
        <div >
          <custom-bread-crumb show-icon :list="breadCrumbList"></custom-bread-crumb>
        </div>
        <Content>
          <Layout>
            <Content class="content-wrapper" style="min-height: 600px;">
              <keep-alive :include="cacheList">
                <router-view />
              </keep-alive>
            </Content>
          </Layout>
          <chat></chat>
        </Content>
        <Footer>
          <div class="copyright">
            <Icon type="sbz"></Icon>
            上海上班族数字科技有限公司技术支持
          </div>
        </Footer>
      </Layout>
    </Layout>
  </Layout>
</template>
<script>
import SideMenu from './components/side-menu';
import HeaderBar from './components/header-bar';
import siderTrigger from './components/header-bar/sider-trigger';
import User from './components/user';
import customBreadCrumb from './components/header-bar/custom-bread-crumb';
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import { getNewTagList, routeEqual } from '@/libs/util';
import routers from '@/router/routers';
import chat from '@/view/qiye/communicate/index';

import './main.less';
export default {
  name: 'Main',
  components: {
    siderTrigger,
    SideMenu,
    HeaderBar,
    User,
    customBreadCrumb,
    chat
  },
  data() {
    return {
      collapsed: false,
      isFullscreen: false,
      mode: localStorage.getItem('mode')
    };
  },
  computed: {
    ...mapGetters(['errorCount']),
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    tagRouter() {
      return this.$store.state.app.tagRouter;
    },
    userAvatar() {
      return this.$store.state.user.myInfo.avatar;
    },
    userName() {
      return this.$store.state.user.myInfo.name || this.$store.state.user.userName;
    },
    cacheList() {
      const list = [
        'ParentView',
        ...(this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : [])
      ];
      return list;
    },
    menuList() {
      return this.$store.getters.menuList;
    },
    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    },
    ...mapState({
      userProfile: state => state.user.userProfile
    }),
    totalUnreadCount() {
      return this.$store.getters.totalUnreadCount;
    },
    breadCrumbList() {
      return this.$store.state.app.breadCrumbList;
    }
  },
  methods: {
    ...mapMutations(['setBreadCrumb', 'setTagNavList', 'addTag', 'setLocal', 'setHomeRoute', 'closeTag']),
    ...mapActions(['handleLogin']),
    turnToPage(route) {
      this.$eventBus.$emit('closeChat');
      if (route === 'communicateIndex') {
        this.$eventBus.$emit('openChat');
        return;
      }
      let { name, params, query } = {};
      if (typeof route === 'string') name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1]);
        return;
      }
      this.$router.push({
        name,
        params,
        query
      });
    },
    handleCollapsedChange(state) {
      this.collapsed = state;
    },
    handleCloseTag(res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage(this.$config.homeName);
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route);
          }
        }
      }
      this.setTagNavList(res);
    },
    handleClick(item) {
      this.turnToPage(item);
    },
    gpPage(path) {
      this.$router.push({
        name: path
      });
    }
  },
  watch: {
    $route(newRoute) {
      const { name, query, params, meta } = newRoute;
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      });
      this.setBreadCrumb(newRoute);
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
      this.$refs.sideMenu.updateOpenName(newRoute.name);
    }
  },
  mounted() {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList();
    this.setHomeRoute(routers);
    const { name, params, query, meta } = this.$route;
    this.addTag({
      route: { name, params, query, meta }
    });
    this.setBreadCrumb(this.$route);
    // 设置初始语言
    this.setLocal(this.$i18n.locale);
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      });
    }
  }
};
</script>
